window.theme = window.theme || {};

theme.config = {
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Makani (4.5.0) by Akshay Vaghasiya | Learn more at https://akshayvaghasiya.com');
}

/* ================ Theme Editor API ================ */
window.theme = window.theme || {};

theme.delegate = {
  on: function(event, callback, options){
    if( !this.namespaces ) // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split('.')[0], callback, options);
    return this;
  },
  off: function(event) {
    if (!this.namespaces) { return }
    this.removeEventListener(event.split('.')[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  }
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;

theme.utils = {
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  wrap: function(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function(wait, callback, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    }
  },

  throttle: function(limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    }
  },

  prepareTransition: function(el, callback) {
    el.addEventListener('transitionend', removeClass);

    function removeClass(evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }

    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === 'function') {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function(array) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
};

theme.a11y = {
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
      ? 'focusout.' + options.namespace
      : 'focusout',
      keydown: options.namespace
      ? 'keydown.' + options.namespace
      : 'keydown.handleFocus'
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter(el => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    document.documentElement.off('focusin');
    document.documentElement.on(eventsName.focusout, function() {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.container) {
      options.container.removeAttribute('tabindex');
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function(namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add('lock-scroll');
    el.on('touchmove' + namespace, function() {
      return true;
    });
  },

  unlockMobileScrolling: function(namespace, element) {
    document.documentElement.classList.remove('lock-scroll');
    var el = element ? element : document.documentElement;
    el.off('touchmove' + namespace);
  }
};

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
        'shopify:section:load',
        this._onSectionLoad.bind(this)
    );
    document.addEventListener(
        'shopify:section:unload',
        this._onSectionUnload.bind(this)
    );
    document.addEventListener(
        'shopify:section:select',
        this._onSelect.bind(this)
    );
    document.addEventListener(
        'shopify:section:deselect',
        this._onDeselect.bind(this)
    );
    document.addEventListener(
        'shopify:block:select',
        this._onBlockSelect.bind(this)
    );
    document.addEventListener(
        'shopify:block:deselect',
        this._onBlockDeselect.bind(this)
    );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var id = container.getAttribute('data-section-id');
        var type = container.getAttribute('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = document.querySelector(
            '[data-section-id="' + evt.detail.sectionId + '"]'
        );

        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        this.instances = this.instances.filter(function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;

            if (isEventInstance) {
                if (typeof instance.onUnload === 'function') {
                    instance.onUnload(evt);
                }
            }

            return !isEventInstance;
        });
    },

    _onSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onSelect === 'function'
        ) {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onDeselect === 'function'
        ) {
            instance.onDeselect(evt);
        }
    },

    _onBlockSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockSelect === 'function'
        ) {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockDeselect === 'function'
        ) {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
            function (container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    }
});


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderPoints = this.querySelectorAll('.slider-points .slider-points__item');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
    this.sliderPoints.forEach((e) => {
      let pointPosition = parseInt(e.getAttribute('data-media-position'));
      e.removeAttribute('aria-current');
      if (pointPosition == this.currentPage) e.setAttribute('aria-current', true);
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}
customElements.define('slider-component', SliderComponent);

// Cart Refresh and Build Functions
function addToCartSuccess() {
  fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart?section_id=cart-drawer")
  .then(response => response.text())
  .then((data) => {
    const id = "CartDrawerForm";
    const html = new DOMParser().parseFromString(data, 'text/html')
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelector('#crt').classList.remove('loading');
    
    // Cart Timer Refresh
	document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
    
  }).catch((e) => {
    // handle error
    console.error(e);
  });
}


function refreshCart(cart) {
  var cartBubble = document.querySelector('.Header__CartDot');
  var EmptyCart = document.querySelector('.empty-cart');
  var NonEmptyCart = document.querySelector('.nonempty-cart');
  //console.log('Xxx');
  if(cart.item_count > 0){
    cartBubble.classList.add('is-visible');
    cartBubble.textContent = cart.item_count;
    EmptyCart.classList.add('hidden');
    NonEmptyCart.classList.remove('hidden');
  } else {
    cartBubble.classList.remove('is-visible');
    cartBubble.textContent = cart.item_count;
    EmptyCart.classList.remove('hidden');
    NonEmptyCart.classList.add('hidden');
  }
}

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.changeItem = function(variant_id, quantity, callback) {
  var params = {
    type: 'POST',
    url: (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+'cart/change.js',
    data:  'quantity='+quantity+'&id='+variant_id,
    dataType: 'json',
    success: function(cart) { 
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  // Shopify returns a description of the error in XMLHttpRequest.responseText.
  // It is JSON.
  // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

/*
 *======================
 * Cart Timer
 *======================
*/
theme.CartTimer = (function() {
  var checkout = {
    strings: {
      timerEndMessage: theme.settings.cartTimerEnd
    }
  };

  function currentDate(currentHash, varName, callback) {
    if (callback) {
      var date = new Date;
      date.setTime(date.getTime() + 60 * callback * 1000);
      var sufix = "; expires=" + date.toUTCString();
    } else {
      sufix = "";
    }
    document.cookie = currentHash + "=" + varName + sufix + "; path=/";
  }

  function resultDataCookie(selector) {
    var result = selector + "=";
    var definedDrops = document.cookie.split(";");
    var i = 0;
    for (; i < definedDrops.length; i++) {
      var def = definedDrops[i];
      for (; " " == def.charAt(0);) {
        def = def.substring(1, def.length);
      }
      if (0 == def.indexOf(result)) {
        return def.substring(result.length, def.length);
      }
    }
    return null;
  }

  function existingSourceCookie(newhash) {
    currentDate(newhash, "", -1);
  }

  function stTM(string, n, elem) {
    function showOrHideJumpToNewPostButton() {
      _ref4 = n - ((Date.now() - string) / 1000 | 0);
      id = _ref4 % 60 | 0;
      url = (url = _ref4 / 60 | 0) < 10 ? "0" + url : url;
      id = id < 10 ? "0" + id : id;
      elem.textContent = url + ":" + id;
      if (_ref4 <= 0) {
        clearInterval(chat_retry);
        const timerWrapper = document.querySelectorAll(".Timer__wrapper")
        for (const wrapper of timerWrapper) {
          wrapper.innerHTML = checkout.strings.timerEndMessage;
        }
        string = Date.now() + 1000;
      }
    }
    var _ref4;
    var url;
    var id;
    showOrHideJumpToNewPostButton();
    var chat_retry = setInterval(showOrHideJumpToNewPostButton, 1000);
  }

  window.initPCCS = init;

  function init() {
    var discountText,
        display;
    if (document.querySelector("#CartDrawerForm")) {
      var numAddresses = 600;
      var currentNumber = Date.now();
      var connectNumber = resultDataCookie("pRtC");
      if (connectNumber) {
        if (currentNumber < connectNumber) {
          numAddresses = (connectNumber - currentNumber) / 1000;
        } else {
          existingSourceCookie("pRtC");
          currentDate("pRtC", Date.now() + 1000 * numAddresses, numAddresses + 1);
        }
      } else {
        currentDate("pRtC", Date.now() + 1000 * numAddresses, numAddresses + 1);
      }

      const timers = document.querySelectorAll(".Time");
      for (const timer of timers) {
        stTM(currentNumber, numAddresses, timer);
      }
    }
  }

  // On Cart Timer Refresh Event Reload Timer again
  window.on('cartdrawer:refresh', function(event) {
    init();
  });            
              
  document.addEventListener('cartdrawer:refresh', function(event) {
    init();
  });

  var reloadTimer = debounce((event) => {
    // Cart Timer Refresh
    document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
  }, 800);
  
  return {
    init: init,
    reloadTimer: reloadTimer
  };
})(); 

var timerDebounce = debounce((event) => {
  // Cart Timer Refresh
  document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
}, 800);

// Trap Focus
function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('.deferred-media video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

theme.Dom = (function() {
  /**
   * Get all the previous and next siblings, optionally filtered by a selector
  */
  function getSiblings(element, filter) {
    var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var siblings = [];
    var currentElement = element; // Do the previous first

    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    } // Then the next side


    currentElement = element;

    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  /**
     * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
     * we need to normalize it
     */
  function nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }

  /**
     * Calculate an element width with its margin
     */
  function outerWidthWithMargin(element) {
    var width = element.offsetWidth,
        style = getComputedStyle(element);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
  }

  /**
   * Calculate an element height with its margin
   */
  function outerHeightWithMargin(element) {
    var height = element.offsetHeight,
        style = getComputedStyle(element);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
  }

  return {
    getSiblings: getSiblings,
    nodeListToArray: nodeListToArray,
    outerWidthWithMargin: outerWidthWithMargin,
    outerHeightWithMargin: outerHeightWithMargin
  };
})();

theme.Drawers = (function() {
  function Drawers(id, name) {
    this.config = {
      id: id,
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + name,
      openClass: 'js-drawer-open',
      closingClass: 'js-drawer-closing',
      activeDrawer: 'drawer--is-open',
      namespace: '.drawer-' + name
    };

    this.nodes = {
      page: document.querySelector('#MainContent')
    };

    this.drawer = document.querySelector('#' + id);
    this.isOpen = false;

    if (!this.drawer) {
      return;
    }

    this.init();
  }

  Drawers.prototype = Object.assign({}, Drawers.prototype, {
    init: function() {
      // Setup open button(s)
      document.querySelectorAll(this.config.open).forEach(openBtn => {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.addEventListener('click', this.open.bind(this));
      });

      this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

      // Close modal if a drawer is opened
      document.addEventListener('modalOpen', function() {
        this.close();
      }.bind(this));
    },

    open: function(evt, returnFocusEl) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        evt.currentTarget.setAttribute('aria-expanded', 'true');
        this.activeSource = evt.currentTarget;
      } else if (returnFocusEl) {
        returnFocusEl.setAttribute('aria-expanded', 'true');
        this.activeSource = returnFocusEl;
      }

      theme.utils.prepareTransition(this.drawer, function() {
        this.drawer.classList.add(this.config.activeDrawer);
      }.bind(this));

      document.documentElement.classList.add(this.config.openClass);
      this.isOpen = true;

      theme.a11y.trapFocus({
        container: this.drawer,
        namespace: 'drawer_focus'
      });

      document.dispatchEvent(new CustomEvent('drawerOpen'));
      document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

      this.bindEvents();
    },

    close: function(evt) {
      if (!this.isOpen) {
        return;
      }

      // Do not close if click event came from inside drawer
      if (evt) {
        if (evt.target.closest('.js-drawer-close')) {
          // Do not close if using the drawer close button
        } else if (evt.target.closest('.drawer')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      theme.utils.prepareTransition(this.drawer, function() {
        this.drawer.classList.remove(this.config.activeDrawer);
      }.bind(this));

      document.documentElement.classList.remove(this.config.openClass);
      document.documentElement.classList.add(this.config.closingClass);

      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false');
          this.activeSource.focus();
        }
      }.bind(this), 500);

      this.isOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.drawer,
        namespace: 'drawer_focus'
      });

      this.unbindEvents();
    },

    bindEvents: function() {
      // Clicking out of drawer closes it
      window.on('click' + this.config.namespace, function(evt) {
        this.close(evt)
        return;
      }.bind(this));

      // Pressing escape closes drawer
      window.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
    },

    unbindEvents: function() {
      window.off('click' + this.config.namespace);
      window.off('keyup' + this.config.namespace);

      theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
    }
  });

  return Drawers;
})();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class VideoMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('video-media', VideoMedia);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

/*
if (!customElements.get('media-slideshow')) {
  class MediaSlideshow extends HTMLElement {
    constructor() {
      super();

      this.delegateElement = new Delegate(document.body);
      let mainSlider = (this.mediaSlideshow = this.querySelector('[data-productgallery]'));

      if (!mainSlider) return;
      this.slides = this.mediaSlideshow.querySelectorAll('.Product__media-item');

      this.mediaThumbnailsScrolling = this.querySelector('.media__thumbnails--scrolling');
      if (this.mediaThumbnailsScrolling) {
        this.mediaThumbnails = this.mediaThumbnailsScrolling.querySelectorAll(
          '.media__thumbnail'
        );
      }

      this.headerHeight = document.getElementById('shopify-section-header').offsetHeight;

     this.bindEvents();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        // Initialize  Slider once media visible
        this.initSlideshow();
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    bindEvents() {
      if (this.mediaSlideshow.classList.contains('.flickity-enabled') > 0) {
        if (this.mediaThumbnails) {
          this.mediaThumbnails.forEach((thumbnail,index) => {
            thumbnail.addEventListener('click', () => this.selectThumbnail(index));
          })
        }
      } else {
        if (this.mediaThumbnails) {
          this.mediaThumbnails.forEach((thumbnail,index) => {
            thumbnail.addEventListener('click', () => this.selectMainMedia(index));
          })
        }
      }
    }
    
    initSlideshow() {
      // Main
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index);
      })
      
      var config = {
        watchCSS: true,
        prevNextButtons: false,
        cellAlign: 'left',
        imagesLoaded: true,
        adaptiveHeight: true,
        initialIndex: 0,
        dragThreshold: 8,
        wrapAround: false
      }
      
      this.main = new Flickity(this.mediaSlideshow, config);

      // Resize Main
      this.main.on('ready', (event) => {
        this.onResize();
      });
      
      // Thumbnails
      if (this.slideshowThumbnails) {

        var thumbnailConfig = {
          "asNavFor": this.mediaSlideshow,
          "draggable": false,
          "percentPosition": false,
          "groupCells": "100%",
          "pageDots": false,
          "prevNextButtons": false
        }

       //this.thumbnails = new Flickity(this.slideshowThumbnails, thumbnailConfig);
      }
      
      // add this code
      Flickity.prototype._createResizeClass = function() {
        this.element.classList.add('flickity-resize');
      };

      Flickity.createMethods.push('_createResizeClass');

      var resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function() {
        this.element.classList.remove('flickity-resize');
        resize.call( this );
        this.element.classList.add('flickity-resize');
      };
    }

    selectThumbnail(index) {
      const activeIndex = Number(index);

      this.main.select(activeIndex);
    }

    selectMainMedia(index) {
      const activeIndex = Number(index);
      var activeElement = this.slides[`${activeIndex}`];
      var elementPosition = activeElement.offsetTop;
      var elementTop = this.headerHeight + 20;
      window.scrollTo({ top: elementPosition + elementTop , behavior: 'smooth'});
      // activeElement.scrollIntoView({top: elementPosition - elementTop, behavior: 'smooth', block: 'center', inline: 'center'});
    }

    setActiveMedia(mediaId) {
      const activeSlide = this.querySelector(`.Product__media-item[data-media-id="${mediaId}"]`);
      if (!activeSlide) return;
      const activeSlideIndex = Number(activeSlide.dataset.slideIndex);

      if(this.main.isActive == true) {
        this.main.select(activeSlideIndex);
      } else {
        var activeElement = this.slides[`${activeSlideIndex}`];
        var elementPosition = activeElement.offsetTop;
        var elementTop = this.headerHeight + 20;
        window.scrollTo({ top: elementPosition + elementTop , behavior: 'smooth'});
      }
    }
    
    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        this.main.resize();
        window.dispatchEvent(new Event('resize'));
      });

      this.slideshowResizeObserver.observe(this.mediaSlideshow);
      
      var _this4 = this;
      // Windows on Resize
      window.addEventListener('resize', function(event){
        _this4.main.resize();
      }, false);
    }
  }
  customElements.define('slider-component', MediaSlideshow);
}
*/

if (!customElements.get('product-gallery')) {
  class MediaSlideshow extends HTMLElement {
    constructor() {
      super();

      this.element = this;
      let mainSlider = (this.mediaSlideshow = this.querySelector('[data-productgallery]'));

      if (!mainSlider) return;
      this.slides = this.mediaSlideshow.querySelectorAll('.Product__media-item');
      let thumbnailSlider = (this.slideshowThumbnails = this.querySelector('.Product__thumbnail'));
      
      this.mediaThumbnailsScrolling = this.querySelector('.media__thumbnails--scrolling');
      if (this.mediaThumbnailsScrolling) {
        this.mediaThumbnails = this.mediaThumbnailsScrolling.querySelectorAll(
          '.media__thumbnail'
        );
      }

     this.bindEvents();
     this.zoomFeature = this.element.dataset.zoom;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        // Initialize  Slider once media visible
        this.initSlideshow();

        if(this.zoomFeature === 'true'){ 
           this.buildImageZoom(); 
        }
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);

    }

    bindEvents() {
      if (this.mediaThumbnails) {
        this.mediaThumbnails.forEach((thumbnail,index) => {
          thumbnail.addEventListener('click', () => this.selectThumbnail(index));
        })
      }
    }

    buildImageZoom() {
      var _this1 = this;
      var galleryId = `#${this.id}`;

      // const closeSVGString = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" aria-hidden="true" class="pswp__icn"><path stroke="#ffffff" stroke-linecap="round" stroke-width="1.5" d="m4 4 16 16M4 20 20 4"/></svg>`;
      const leftArrowSVGString = `<svg width="32" height="32" aria-hidden="true" class="pswp__icn" viewBox="0 0 100 100"><path d="m10 50 50 50 10-10-40-40 40-40L60 0Z"/></svg>`;
      const rightArrowSVGString = `<svg width="32" height="32" aria-hidden="true" class="pswp__icn" viewBox="0 0 100 100"><path d="M90 50 40 0 30 10l40 40-40 40 10 10Z" transform="translate(100, 100) rotate(180)" /></svg>`;
      
      const lightbox = new PhotoSwipeLightbox({
        // closeSVG: closeSVGString,
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: rightArrowSVGString,
        // may select multiple "galleries"
        gallery: `${galleryId}`,
      
        // Elements within gallery (slides)
        children: 'a',
        padding: { top: 20, bottom: 20, left: 20, right: 20 },
        allowPanToNext: false,
        zoom: false,

        pswpModule: PhotoSwipe
      });
      
      lightbox.init();
    }
    
    initSlideshow() {
      // Main
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index);
      })
      
      var config = {
        prevNextButtons: false,
        cellAlign: 'left',
        imagesLoaded: true,
        adaptiveHeight: true,
        initialIndex: 0,
        dragThreshold: 8,
        wrapAround: false
      }
      
      this.main = new Flickity(this.mediaSlideshow, config);

      this.main.on('change', (newIndex) => {
        var sliderIndex = newIndex;
        if (this.main.selectedCell.element.previousElementSibling) this.playPauseVideo(this.main.selectedCell.element.previousElementSibling, "pause");
      });
      
      this.main.on('settle', (newIndex) => {
        var sliderIndex = newIndex;
        this.playPauseVideo(this.main.selectedCell.element, "play");
      });

      // Resize Main
      this.main.on('ready', (event) => {
        this.onResize();
      });
      
      // Thumbnails
      if (this.slideshowThumbnails) {

        var thumbnailConfig = {
          "asNavFor": this.mediaSlideshow,
          "draggable": false,
          "percentPosition": false,
          "groupCells": "100%",
          "pageDots": false,
          "prevNextButtons": false
        }

       //this.thumbnails = new Flickity(this.slideshowThumbnails, thumbnailConfig);
      }
      
      // add this code
      Flickity.prototype._createResizeClass = function() {
        this.element.classList.add('flickity-resize');
      };

      Flickity.createMethods.push('_createResizeClass');

      var resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function() {
        this.element.classList.remove('flickity-resize');
        resize.call( this );
        this.element.classList.add('flickity-resize');
      };
    }

    selectThumbnail(index) {
      const activeIndex = Number(index);
      this.main.select(activeIndex);
    }

    setActiveMedia(mediaId) {
      const activeSlide = this.querySelector(`.Product__media-item[data-media-id="${mediaId}"]`);
      if (!activeSlide) return;

      const activeSlideIndex = Number(activeSlide.dataset.slideIndex);
      this.main.select(activeSlideIndex);
    }
    
    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        this.main.resize();
        window.dispatchEvent(new Event('resize'));
      });

      this.slideshowResizeObserver.observe(this.mediaSlideshow);
      
      // Windows on Resize
      window.addEventListener('resize', function(event){
        this.main.resize();
        this.mediaSlideshow.querySelector('.flickity-viewport').style.height = null;
        window.dispatchEvent(new Event('resize'));
      }, false);
    }
    
    playPauseVideo(slide, control) {
      var currentSlide, slideType, startTime, player, video;
      currentSlide = (this.activeSlide = slide);
      if (!currentSlide) return; 
      
      let sliderElement = currentSlide.querySelector('.Product__SlideItem');
      slideType = sliderElement.dataset.videoHost;
      player = this.activeSlide.querySelector("iframe");
      startTime = 1;

      if (slideType === "vimeo") {
        switch (control) {
          case "play":
            if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
              postMessageToPlayer(player, {
                "method": "setCurrentTime",
                "value" : startTime
              });
            }
            postMessageToPlayer(player, {
              "method": "play",
              "value" : 1
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              "method": "pause",
              "value": 1
            });
            break;
        }
      } else if (slideType === "youtube") {
        switch (control) {
          case "play":
            postMessageToPlayer(player, {
              "event": "command",
              "func": "mute"
            });
            postMessageToPlayer(player, {
              "event": "command",
              "func": "playVideo"
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              "event": "command",
              "func": "pauseVideo"
            });
            break;
        }
      } else if (slideType === "video") {
        video = this.activeSlide.querySelector("video");
        if (video != null) {
          if (control === "play"){
            video.play();
          } else {
            video.pause();
          }
        }
      }
    }

  }
  customElements.define('product-gallery', MediaSlideshow);
}


class VariantSelects extends HTMLElement {
  constructor() {
    super();

    var _this1 = this;
    this.customDropdown = this.getElementsByClassName("custom_dropdown_selector");

    if(this.customDropdown.length > 0) {
      this.buildCustomDropdown();
      
     document.addEventListener('dropdown:changed', function(event) {
       _this1.addEventListener('click', _this1.onVariantChange);
       _this1.addEventListener('change', _this1.onVariantChange);
       _this1.addEventListener('keydown', _this1.onVariantChange);
     });
    } else {
      this.addEventListener('change', this.onVariantChange);
    }
    
    // this.addEventListener('change', this.onVariantChange);
  }

  buildCustomDropdown() {
    /*dropdown change script start*/
      var x, i, j, selElmnt, a, b, c, wrap, buttonWrap;

      /*look for any elements with the class "custom-select":*/
      x = this.getElementsByClassName("custom_dropdown_selector");
      if (x.length > 0) {
        for (i = 0; i < x.length; i++) {
          selElmnt = x[i].getElementsByTagName("select")[0];

          // We create wrap element for styling and dropdown content
          wrap = document.createElement("DIV");
          wrap.setAttribute("class", "ColorSwatchDropDown__wrap");
          x[i].appendChild(wrap);

          // We create wrap element for styling and dropdown content
          buttonWrap = document.createElement("DIV");
          buttonWrap.setAttribute("class", "ColorSwatchDropDownButton__wrap select-selected");
          buttonWrap.className += ' Select';
          wrap.appendChild(buttonWrap);
          
          /*for each element, create a new DIV that will act as the selected item:*/
          a = document.createElement("DIV");
          a.setAttribute("class", "ColorSwatchButton--trigger");

          if(selElmnt.options[selElmnt.selectedIndex].hasAttribute('data-style-indicate')) {
            var buttonProperties = selElmnt.options[selElmnt.selectedIndex].dataset.styleIndicate.split(':');
            var buttonProperty = buttonProperties[0].trim();
            var buttonValue = buttonProperties[1].trim();

            a.style.setProperty("--swatch-prop", buttonProperty);
            a.style.setProperty("--swatch-value", buttonValue);
          }
          a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          buttonWrap.appendChild(a);

          a.insertAdjacentHTML('afterend', '<svg class="Icon Icon--caret" aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor" /></svg>');
          
          /*for each element, create a new DIV that will contain the option list:*/
          b = document.createElement("DIV");
          b.setAttribute("class", "CustomSwatch__Dropdown--list select-items select-hide");
          
          for (j = 0; j < selElmnt.length; j++) {
            /*for each option in the original select element, create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.setAttribute("class", "CustomSwatch__Dropdown--list-item");
            
            if(selElmnt.options[j].hasAttribute('data-style-indicate')) {

              var styleProperties = selElmnt.options[j].dataset.styleIndicate.split(':');
              var styleProperty = styleProperties[0].trim();
              var styleValue = styleProperties[1].trim();

              c.style.setProperty("--swatch-prop", styleProperty);
              c.style.setProperty("--swatch-value", styleValue);
              c.innerHTML = `${selElmnt.options[j].innerHTML}`;
            } else {
              c.innerHTML = `${selElmnt.options[j].innerHTML}`;
            }
            c.addEventListener("click", function(e) {
              /*when an item is clicked, update the original select box,
              and the selected item:*/
              var y, i, k, s, h, button;
              s = this.parentNode.parentNode.parentNode.getElementsByTagName("select")[0];
              h = this.parentNode.previousSibling;
              button = h.querySelector('.ColorSwatchButton--trigger');

              
              //var z = document.getElementsByClassName("product-single__title")[0];
              for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                  s.selectedIndex = i;
                  var event = new Event('change'); 
                  // Dispatch it.
                  s.dispatchEvent(event);
                  s.dispatchEvent(new CustomEvent('dropdown:changed', { bubbles: true }));

                  if(this.hasAttribute('style')) {
                    var style = this.getAttribute('style');
                    button.setAttribute("style", style);
                  }
                  button.innerHTML = this.innerHTML;
                  //z.innerHTML = this.innerHTML;
                  y = this.parentNode.getElementsByClassName("same-as-selected");
                  for (k = 0; k < y.length; k++) {
                    y[k].classList.remove("same-as-selected");
                  }
                  this.classList.add("same-as-selected");
                  break;
                }
              }
              h.click();
            });
            b.appendChild(c);
          }
          wrap.appendChild(b);
          x[i].appendChild(wrap);
          buttonWrap.addEventListener("click", function(e) {
            /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
          });
        }
        function closeAllSelect(elmnt) {
          /*a function that will close all select boxes in the document,
        except the current select box:*/
          var x, y, i, arrNo = [];
          x = document.getElementsByClassName("select-items");
          y = document.getElementsByClassName("select-selected");
          for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
              arrNo.push(i)
            } else {
              y[i].classList.remove("select-arrow-active");
            }
          }
          for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
              x[i].classList.add("select-hide");
            }
          }
        }
        /*if the user clicks anywhere outside the select box,
        then close all select boxes:*/
          document.addEventListener("click", closeAllSelect);
          /*dropdown change script end*/
        }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      //this.additionalCallback();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const mediaSlideshow = document.getElementById(
      `MediaSlideshow-${this.dataset.section}`
    );
    mediaSlideshow.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', this.dataset.url+'?variant='+this.currentVariant.id);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll('#product-form-'+this.dataset.section);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      
      //Variant selection changed
      const currentVariant = this.currentVariant;
      document.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: currentVariant
        }
      }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(this.dataset.url+'?variant='+this.currentVariant.id+'&section_id='+this.dataset.section)
      .then((response) => response.text())
      .then((responseText) => {
        const id = "price-"+this.dataset.section;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        
        document.getElementById('price-'+this.dataset.section)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        
        // Update Variant Note
        const noteId = "variant-note__"+this.dataset.section;
        const variantNoteDestination = document.getElementById(noteId);
        const variantNoteSource = html.getElementById(noteId);

        if (variantNoteSource && variantNoteDestination) variantNoteDestination.innerHTML = variantNoteSource.innerHTML;
        
        // Saving Badge
        const badge_id = "badge-"+this.dataset.section;
        const BadgeDestination = document.getElementById(badge_id);
        const BadgeSource = html.getElementById(badge_id);

        if (BadgeSource && BadgeDestination) BadgeDestination.innerHTML = BadgeSource.innerHTML;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.querySelector('[name="add"]');
    const btnText = addButton.querySelector('.Btn_Text');
        
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) btnText.textContent = text; 
    } else {
      addButton.removeAttribute('disabled');
      btnText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
       
  additionalCallback() {
    var variant = this.currentVariant;
    const productForms = document.querySelectorAll('#product-form-' + this.dataset.section);
    const FormButtons = document.querySelector('.product-form__buttons');
    const NotifyButton = document.querySelector('.Back--In__stock');
	const productAvailability = document.querySelector('#availibility-' + this.dataset.section);
        
    if (variant) {
        const BISButton = NotifyButton.querySelector('#BIS_trigger');
        if (BISButton) BISButton.dataset.variantId = variant.id;
    }

    if (variant && variant.available) {
        if (FormButtons) FormButtons.removeAttribute('hidden');
        if (NotifyButton) NotifyButton.setAttribute('hidden', '');
        if (productAvailability) productAvailability.removeAttribute('hidden');
    } else {
        if (FormButtons) FormButtons.setAttribute('hidden', '');
        if (NotifyButton) NotifyButton.removeAttribute('hidden');
        if (productAvailability) productAvailability.setAttribute('hidden', '');
    }
  }      

  setUnavailable() {
    const addButton = document.querySelector('[name="add"]');
    const btnText = addButton.querySelector('.Btn_Text');
    if (!addButton) return;
    btnText.textContent = window.variantStrings.unavailable;
    document.getElementById('price-'+this.dataset.section)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

if (!customElements.get('select-redirection')) {
customElements.define('select-redirection', class SelectRedirection extends HTMLElement {
  constructor() {
    super();

    this.productURL = this.dataset.mainUrl;
    this.select = this.querySelector('select');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    var VariantProductURL = this.select.options[this.select.selectedIndex].dataset.productUrl;
      if ( this.productURL != VariantProductURL ){
       window.location.href = VariantProductURL;
     }
  }
});
}
 
if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        
        if (window.theme.cartType === 'drawer') {
          var quantityElement = this.form.querySelector('[name="quantity"]');
          // We simply trigger an event so the mini-cart can re-render
          this.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              quantity: quantityElement ? parseInt(quantityElement.value) : 1
            }
          }));
        }
        
        // Cart Timer Refresh
        document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));            
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');

    // Cart Timer Refresh
      document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
    });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});
}

theme.SearchBar = (function() {
  function SearchBar(element) {
    this.documentDelegate = new Delegate(document.body);
    this.searchElement = document.getElementById('Search');
    this.searchInputElement = this.searchElement.querySelector('[name="q"]');
    this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
    this.queryMap = {};
    this.isOpen = false;
    this.pageOverlayElement = document.querySelector('.PageOverlay');

    this._attachListeners();
  }

  SearchBar.prototype = Object.assign({}, SearchBar.prototype, {
  
  destroy: function () {
    this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
    this.documentDelegate.off();
  },

  _attachListeners: function () {
    this._preventSubmissionListener = this._preventSubmission.bind(this);
    this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
    this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
    this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
    this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
    this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
  },

  _toggleSearch: function (event) {
    if (this.isOpen) {
      this._closeSearch(event);
    } else {
      this._openSearch(event);
    }

    event.preventDefault();
  },
   
  _openSearch: function () {
    var _this = this;

    this.searchElement.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    // Accessibility.trapFocus(this.searchElement, 'search', this.searchElement.querySelector('[name="q"]'));
    theme.a11y.trapFocus({
      container: this.searchElement,
      namespace: 'search'
    });

    var onFocusListener = function onFocusListener() {
      _this.searchInputElement.focus();

      _this.searchElement.removeEventListener('transitionend', onFocusListener);
    };

    this.searchElement.addEventListener('transitionend', onFocusListener);
    this.isOpen = true;
    this.pageOverlayElement.classList.add('is-visible');
    document.querySelector('#shopify-section-header').style.zIndex = 10;
  },

  _closeSearch: function () {
    var _this2 = this;

    this.searchElement.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    // Accessibility.removeTrapFocus(this.searchElement, 'search');
    theme.a11y.removeTrapFocus({
      container: this.searchElement,
      namespace: 'search'
    });

    this.isOpen = false;

    var onTransitionEnd = function onTransitionEnd(event) {
      if (event.propertyName === 'visibility') {
        document.querySelector('#shopify-section-header').style.zIndex = '';

        _this2.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd);
      }
    };

    this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd);
    this.pageOverlayElement.classList.remove('is-visible');
  },

  _preventSubmission: function (event) {
    if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
      event.preventDefault();
    }
  }
});

  return SearchBar;
})();

theme.MobileNavigation = (function() {
  function MobileNavigation(element) {
    
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.documentElement);
    this.mobileMenuElement = this.element.querySelector('.mobile-menu');
    this.mobileMenuToggleElement = this.element.querySelector("[aria-controls=\"".concat(this.mobileMenuElement.id, "\"]"));
    this.isOpen = false;

    this._attachListeners();
  }

  MobileNavigation.prototype = Object.assign({}, MobileNavigation.prototype, {
  
  destroy: function () {
    this.delegateElement.off();
    this.delegateRoot.off();
    window.removeEventListener('resize', this._calculatMaxHeightListener);
  },

  _attachListeners: function () {
    this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this);
    this.delegateElement.on('click', '[data-action="toggle-menu"]', this._toggleMenu.bind(this));
    this.delegateRoot.on('click', this._onWindowClick.bind(this));
    window.addEventListener('resize', this._calculatMaxHeightListener);
  },

  _toggleMenu: function () {
    this.isOpen = !this.isOpen;
    this.mobileMenuToggleElement.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
    this.mobileMenuElement.setAttribute('aria-hidden', this.isOpen ? 'false' : 'true');

    if (!this.isOpen) {
      this.mobileMenuElement.style.maxHeight = ''; // If closed, we need to close all sub-menus

      document.body.classList.remove('no-mobile-scroll');
      document.querySelector('#shopify-section-header').classList.remove('no-transparent-background');
    } else {
      // We need to restrict the height
      this._calculateMaxHeight();

      document.body.classList.add('no-mobile-scroll');
      document.querySelector('#shopify-section-header').classList.add('no-transparent-background');
    }
  },
   
  _calculateMaxHeight: function () {
    if (this.isOpen) {
      this.mobileMenuElement.style.maxHeight = "".concat(window.innerHeight - document.querySelector('.Header').getBoundingClientRect().bottom, "px");
    }
  },

  _onWindowClick: function (event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this._toggleMenu();
    }
  }
});

  return MobileNavigation;
})();

theme.HeaderSection = (function() {

  function HeaderSection(container) {
    var _this = this;

    this.element = container;
    this.delegateElement = new Delegate(this.element);
  
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.lastScrollPosition = -1;
    this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;

    this.searchBar = new theme.SearchBar();
    this._attachListeners();

    this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS
    
    var mainLogo = this.element.querySelector('.Header__LogoImage--primary');

    if (mainLogo && !mainLogo.complete) {
      mainLogo.addEventListener('load', function () {
        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
          document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
        });
      });
    } else {
      fastdom.measure(function () {
        document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
        document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
      });
    }

    var mobileNavigationElement = this.element.querySelector('[data-action="drawer-menu"]');

    if (mobileNavigationElement) {
      this.mobileNavigation = new theme.MobileNavigation(mobileNavigationElement);
    }

    window.addEventListener('pageshow', this._checkTransparentHeader.bind(this));
    
    // window.addEventListener('resize', function(event){
    //   document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');        
    //   document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement-bar').offsetHeight + 'px');
    // });
  }
  
  HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
    onUnload: function() {
      this.element.removeEventListener('mouseleave', this._closeNavigationListener);
      this.element.removeEventListener('mouseenter', this._focusNavigationListener);
      this.element.removeEventListener('focusin', this._focusNavigationListener);
      this.delegateElement.off();
      window.removeEventListener('scroll', this._checkTransparentHeaderListener);
      window.removeEventListener('resize', this._verifyNavigationOverlapListener);

//       if (this.mobileNavigation) {
//         this.mobileNavigation.destroy();
//       }
    },

    onSelect: function() {
      this._checkTransparentHeader();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(event) {
      var _this2 = this;

      var listItem = event.target.closest('.HorizontalList__Item');
      fastdom.mutate(function () {
        event.target.setAttribute('aria-hidden', 'false');

        if (listItem) {
          listItem.classList.add('is-expanded');
          theme.Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
          });
        }

        _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible

      });
    },

    onBlockDeselect: function(event) {
      var listItem = event.target.closest('.HorizontalList__Item');
      fastdom.mutate(function () {
        event.target.setAttribute('aria-hidden', 'true');

        if (listItem) {
          listItem.classList.remove('is-expanded');
        }
      });

      this._checkTransparentHeader();
    },

    _attachListeners: function() {
      this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
      this._closeNavigationListener = this._closeNavigation.bind(this);
      this._focusNavigationListener = this._focusNavigation.bind(this);
      this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
      this.element.addEventListener('mouseleave', this._closeNavigationListener);
      this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, [aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
      this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
      this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
      this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);
      this.delegateElement.on('click', '[data-action="toggle-menu"]', this._focusMobileNavigation.bind(this));

      if (this.isTouch) {
        this.delegateElement.on('click', '.Header__MainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
      }

      if (this.options['hasTransparentHeader']) {
        this.element.addEventListener('mouseenter', this._focusNavigationListener);
        this.element.addEventListener('focusin', this._focusNavigationListener);
      }

      if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
        window.addEventListener('scroll', this._checkTransparentHeaderListener);
      }

      if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
        window.addEventListener('resize', this._verifyNavigationOverlapListener);
      }
    },

    _focusNavigation: function() {
      var _this3 = this;

      fastdom.mutate(function () {
        if (!_this3.isTouch || window.matchMedia('screen and (min-width: 1008px)').matches) {
          _this3.element.classList.remove('Header--transparent');
        }
        //_this3.element.classList.remove('Header--transparent');
      });
    },

    
    _focusMobileNavigation: function() {
      var _this7 = this;

      fastdom.mutate(function () {
        if(_this7.element.classList.contains('Header--transparent')) {
          _this7.element.classList.remove('Header--transparent');
        }
      });
    },

    _closeNavigation: function() {
      var _this4 = this;

      fastdom.mutate(function () {
        theme.Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (item) {
          item.classList.remove('is-expanded');
        });
        theme.Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
          // document.querySelector('.MegaMenu__Overlay').classList.remove('is-visible');
        });
      });

      if (this.options['hasTransparentHeader']) {
        this._checkTransparentHeader();
      }
    },

    _openMenu: function(event, target) {
      if (event.type === 'mouseenter' && target !== event.target) {
          return;
        }

        fastdom.mutate(function () {
          target.classList.add('is-expanded');

          theme.Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'false');
            // document.querySelector('.MegaMenu__Overlay').classList.add('is-visible');
          });
          theme.Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
            theme.Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
              item.setAttribute('aria-hidden', 'true');
              // document.querySelector('.MegaMenu__Overlay').classList.remove('is-visible');
            });
          });
        });
    },

    _closeMenu: function(event, target) {
      if (event.type === 'mouseleave' && target !== event.target) {
          return;
      }

      fastdom.mutate(function () {
        target.classList.remove('is-expanded');
        theme.Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
          // document.querySelector('.MegaMenu__Overlay').classList.remove('is-visible');
        });
      });
    },

    _adjustDropdownPosition: function(event, target) {
      var nestedMenus = theme.Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
          shouldOpenLeft = false;
      fastdom.measure(function () {
        var windowWidth = window.innerWidth,
            rightEdge = target.getBoundingClientRect().right;
        nestedMenus.forEach(function (item) {
          if (rightEdge + item.offsetWidth > windowWidth) {
            shouldOpenLeft = true;
          }
        });
      });
      fastdom.mutate(function () {
        if (shouldOpenLeft) {
          nestedMenus.forEach(function (item) {
            item.classList.add('DropdownMenu--reversed');
          });
        } else {
          nestedMenus.forEach(function (item) {
            item.classList.remove('DropdownMenu--reversed');
          });
        }
      });
    },

    _handleTouchMenu: function(event, target) {
      if (!target.classList.contains('is-expanded')) {
        event.preventDefault();
      }
    },

    _verifyNavigationOverlap: function() {
      var _this5 = this;

      var isOverlapping = false,
          mainTopMenu = this.element.querySelector('.Header__MainNav');
      fastdom.measure(function () {
        // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
        if (mainTopMenu) {
          // Get the first element
          var firstNavElementHeight = theme.Dom.outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
              mainNavHeight = mainTopMenu.scrollHeight;

          if (mainNavHeight > firstNavElementHeight) {
            isOverlapping = true;
          }
        }
      });
      this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
      this.element.classList.add("Header--".concat(this.options['navigationStyle']));
      this.element.clientWidth; // Forces a reflow

      fastdom.mutate(function () {
        if (isOverlapping) {
          _this5.element.classList.remove("Header--".concat(_this5.options['navigationStyle']));

          _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode


          if (mainTopMenu) {
            // Get the first element
            var itemTopSet = new Set();
            Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (item) {
              itemTopSet.add(item.getBoundingClientRect().top);
            });
            isOverlapping = itemTopSet.size > 1;
          }
        } else {
          _this5.element.classList.add("Header--".concat(_this5.options['navigationStyle']));

          _this5.element.classList.remove('Header--center');
        }

        var logo = _this5.element.querySelector('.Header__FlexItem--logo');

        logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping);

        _this5.element.classList.add('Header--initialized');

        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
        });
      });
    },

    _checkTransparentHeader: function() {
      var _this6 = this;

      if (!this.options['hasTransparentHeader']) {
        return;
      }

      var scrollThreshold = 10;
      fastdom.measure(function () {
        _this6.lastScrollPosition = window.pageYOffset;
      });
      fastdom.mutate(function () {
        if (_this6.lastScrollPosition <= scrollThreshold) {
          _this6.element.classList.add('Header--transparent');
        } else {
          _this6.element.classList.remove('Header--transparent');
        }
      });
    }

  });

  return HeaderSection;
})();


theme.Collapsibles = (function() {
  function Collapsibles(container) {
    var $element = (this.element = container);
    let accHeading = document.querySelectorAll(".collapsible-trigger");
    let accPanel = document.querySelectorAll(".collapsible-content");
    let isFirstShowing = false;

    for (let i = 0; i < accHeading.length; i++) {
      // Execute whenever an accordion is clicked 
      accHeading[i].onclick = function() {
        if (this.nextElementSibling.style.maxHeight) {
          hidePanels();     // Hide All open Panels 
        } else {
          showPanel(this);  // Show the panel
        } 
      };
    }

    // Function to Show a Panel
    function showPanel(elem) {
      hidePanels();
      elem.classList.add("collapsible-trigger--active");
      elem.nextElementSibling.style.maxHeight = elem.nextElementSibling.scrollHeight + "px";
    }

    // Function to Hide all shown Panels
    function hidePanels() {
      for (let i = 0; i < accPanel.length; i++) {
        accPanel[i].style.maxHeight = null;
        accHeading[i].classList.remove("collapsible-trigger--active");
      }
    }
  }

  return Collapsibles;
})();

theme.CollapsibleManager = (function() {
  function CollapsibleManager() {
    var _this = this;
    this.domDelegate = new Delegate(document.body);
    this._attachListeners(); 
  }

  CollapsibleManager.prototype = Object.assign({}, CollapsibleManager.prototype, {
    _attachListeners: function() {
      this.domDelegate.on('click', '[data-action="toggle-collapsible"]:not([disabled])', this._toggleCollapsible.bind(this));
      
      document.addEventListener('collapsible:toggle', this._toggleCollapsible.bind(this));
    },

    /**
     * Toggle a given collapsible
     */

    _toggleCollapsible: function(event, target) {
      var _this = this;
      
      // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
      var parentCollapsible = target.parentNode;

      if (parentCollapsible.classList.contains('Collapsible--autoExpand') && window.matchMedia('screen and (min-width: 641px)').matches) {
        return;
      }

      // If the target is null, it may be because someone has sent the global event "collapsible:toggle". If that the case
      // we can retrieve the toggle button by using the event.detail.id
      if (!target && event.detail) {
        target = document.querySelector("[aria-controls=\"".concat(event.detail.id, "\"]"));
      }

      var isOpen = target.getAttribute('aria-expanded') === 'true',
          parentCollapsible = target.parentNode;

      if (isOpen) {
        this._close(parentCollapsible);
      } else {
        this._open(parentCollapsible);
      } // We make sure to close any siblings collapsible as well


      if (target.getAttribute('data-close-siblings') !== 'false') {
        theme.Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
          return _this._close(collapsibleToClose);
        });
      }
      event.preventDefault();
    },


    /**
     * Open a given collapsible
     */

   _open: function (collapsible) {
      var toggleButton = collapsible.querySelector('[aria-controls]');

      if (!toggleButton || toggleButton.getAttribute('aria-expanded') === 'true') {
        return; // It's already open
      }

      var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute('aria-controls')));
      toggleButton.setAttribute('aria-expanded', 'true');

      if (collapsibleContent.hasAttribute('aria-hidden')) {
        collapsibleContent.setAttribute('aria-hidden', 'false');
      }

      if (collapsibleContent.style.maxHeight === 'auto') {
        return;
      } // To do the animation we temporarily hide it, check the height, and transition to it
  
      collapsibleContent.style.maxHeight = "".concat(collapsibleContent.firstElementChild.scrollHeight, "px");

      if (toggleButton.hasAttribute('data-collapsible-force-overflow')) {
        collapsibleContent.style.overflow = 'visible';
      } 
      
      // If there is an autofocus field, we focus it
      var autofocusElement = collapsibleContent.querySelector('[autofocus]');

      if (autofocusElement) {
        autofocusElement.focus();
      }
    },
    /**
     * Close a given collapsible
     */

  _close:function (collapsible) {
      var toggleButton = collapsible.querySelector('[aria-controls]');

      if (!toggleButton || toggleButton.getAttribute('aria-expanded') === 'false') {
        return; // It's already closed
      }

      var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute('aria-controls')));

      if (toggleButton.hasAttribute('data-collapsible-force-overflow')) {
        collapsibleContent.style.overflow = 'hidden';
      }

      if (collapsibleContent.hasAttribute('aria-hidden')) {
        collapsibleContent.setAttribute('aria-hidden', 'true');
      }

      toggleButton.setAttribute('aria-expanded', 'false');
      collapsibleContent.style.maxHeight = "".concat(collapsibleContent.scrollHeight, "px"); // Force previous height to allow CSS transition
      collapsibleContent.offsetHeight; // Force redraw
      collapsibleContent.style.maxHeight = 0;
    }
    
  });

  return CollapsibleManager;
})();

theme.Responsive = (function() {
  class Responsive {
    constructor() {
      var _this = this;

      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();

        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }

        document.dispatchEvent(new CustomEvent('breakpoint:changed', {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          }
        }));
        _this.currentBreakpoint = newBreakpoint;
      });
    }
  }

  Responsive.prototype = Object.assign({}, Responsive.prototype, {
    matchesBreakpoint: function(breakpoint) {
      switch (breakpoint) {
        case 'phone':
          return window.matchMedia('screen and (max-width: 640px)').matches;

        case 'tablet':
          return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

        case 'tablet-and-up':
          return window.matchMedia('screen and (min-width: 641px)').matches;

        case 'pocket':
          return window.matchMedia('screen and (max-width: 1007px)').matches;

        case 'lap':
          return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

        case 'lap-and-up':
          return window.matchMedia('screen and (min-width: 1008px)').matches;

        case 'desk':
          return window.matchMedia('screen and (min-width: 1280px)').matches;

        case 'widescreen':
          return window.matchMedia('screen and (min-width: 1600px)').matches;

        case 'supports-hover':
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      }
    },

  getCurrentBreakpoint: function() {
      if (window.matchMedia('screen and (max-width: 640px)').matches) {
        return 'phone';
      }

      if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
        return 'tablet';
      }

      if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
        return 'lap';
      }

      if (window.matchMedia('screen and (min-width: 1280px)').matches) {
        return 'desk';
      }
    }

  });

  return Responsive;
})();

theme.FeaturedCollection = (function() {

  function FeaturedCollection(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var mobileSlider = container.dataset.mobileSlider;
    var slideshow = '#featured-collection-' + sectionId;

    if (mobileSlider === 'false') return; 

    var config = {
      watchCSS: true,
      wrapAround: false,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true
    }

    this.slideshow = new Flickity(slideshow, config);
    
    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };

  }
  
  FeaturedCollection.prototype = Object.assign({}, FeaturedCollection.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    }
  });

  return FeaturedCollection;
})();

theme.RecommendationSlider = (function() {

  function RecommendationSlider(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var mobileSlider = container.dataset.mobileSlider;
    
    if (mobileSlider === 'false') return; 
    
    function Recommendation() {
      if($('.Recommendations__Grid').length){ 

        var elem = document.querySelector('.Recommendations__Grid');
        this.slideshow = new Flickity( elem, {
          // options
          watchCSS: true,
          wrapAround: false,
          cellAlign: 'left',
          prevNextButtons: false,
          pageDots: true,
          imagesLoaded: true
        });
        
        // add this code
        Flickity.prototype._createResizeClass = function() {
          this.element.classList.add('flickity-resize');
        };

        Flickity.createMethods.push('_createResizeClass');

        var resize = Flickity.prototype.resize;
        Flickity.prototype.resize = function() {
          this.element.classList.remove('flickity-resize');
          resize.call( this );
          this.element.classList.add('flickity-resize');
        };

        
      } else {
        setTimeout(function(){
          Recommendation();	
        }, 1000);
      }
    }

    Recommendation();
  }

  return RecommendationSlider;
})();

if (!customElements.get('mega-menu')) {
  customElements.define('mega-menu', class MegaMenuSlider extends HTMLElement {
    constructor() {
      super();

      var _this1 = this;
      var slideshowElement = (this.slideshowElement = this.querySelector('[data-action="mega-slider"]'));
      
      if(!slideshowElement) return;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        // Initialize  Slider once media visible
        this.initSlideshow();
      }
      
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    initSlideshow(){
      this.slideshow = new Flickity( this.slideshowElement, {
        // options
        wrapAround: true,
        cellAlign: 'left',
        prevNextButtons: true,
        pageDots: false,
        imagesLoaded: true
      });
    }
    
  });
}

if (!customElements.get('complementory-products')) {
  customElements.define('complementory-products', class ComplementoryProducts extends HTMLElement {
    constructor() {
        super();
        this.section = this;
        this._attachListeners.bind(this);
        document.addEventListener('cart:drawer:updated', this._attachListeners.bind(this));
      }

      _attachListeners(){
        var _this1 = this;
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
  
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('complementory-products');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML; 
                
                // Fire Event to build slider
                document.dispatchEvent(new CustomEvent('complementory:loaded', {
                  detail: {
                    section: _this1.section
                  }
                }));
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
  
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      }
  });
}

class PromoComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('[data-slide-button]');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.promo__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.promo__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}
customElements.define('promo-component', PromoComponent);

if (!customElements.get('complementory-card')) {
  customElements.define('complementory-card', class ComplementoryCard extends HTMLElement {
    constructor() {
    super();

    this.buyBox = this.querySelector('.UpsellItem__buybox');
    this.buyBox.querySelector('[data-card-button]').addEventListener('click', this.onSubmitHandler.bind(this));
  }

    onSubmitHandler(evt) {
        evt.preventDefault();
        var _this2 = this;
        const submitButton = this.querySelector('[data-card-button]');
        if (submitButton.classList.contains('loading')) return; 

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');

        const selectedVariant = this.querySelector('input[name="id"]').value;

        let formData = {
          'items': [{
           'id': selectedVariant,
           'quantity': 1
           }]
         };

         fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+'cart/add.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(formData)
         }).then(function(response) {
            return response.json();
          }).then(function(json) {
            if (window.theme.cartType === 'drawer') {
              // We simply trigger an event so the mini-cart close before rerender
              document.dispatchEvent(new CustomEvent('cart:close'));
              
              // We simply trigger an event so the mini-cart can re-render
              _this2.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  quantity: 1
                }
              })); 
            }
            
            // Cart Drawer Refresh
            document.dispatchEvent(new CustomEvent('cartdrawer:refresh')); 
          }).catch(function(e) {
            /* uh oh, we have error. */
            console.error(e);
          }).finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
    
          // Cart Drawer Refresh
            document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
          });
    }
  });
}

if (!customElements.get('product-timer')) {
  customElements.define('product-timer', class ProductTimer extends HTMLElement {
    constructor() {
      super();

      var _this1 = this;
      this.onTimerIntialize();
    }
  
    onTimerIntialize(container) {
      let _this2 = this;
      var $container = (this.$container = this);
      var $parent = $container.querySelector('.Product__dealArea');
      var sectionId = $parent.getAttribute('data-section-id');
      var DealTimer = this.$container.querySelector('#timer-' + sectionId);
      var endTime = $parent.getAttribute("data-enddate");
      
      // Set the date we're counting down to
      var countDownDate = new Date(endTime).getTime();

      // Update the count down every 1 second
      var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        let countedDays = days;
        
        if (days < 10) days = "0" + days;
        if (hours < 10) hours = "0" + hours;
        if (minutes < 10) minutes = "0" + minutes;
        if (seconds < 10) seconds = "0" + seconds;
        
        // Display the result in the element
        if (countedDays > 0 && countedDays > 7) {
          DealTimer.innerHTML = `kurze Zeit`;
        } else if (countedDays > 0 && countedDays <= 7) {
          DealTimer.innerHTML = `${days}:${hours}:${minutes}:${seconds}`;
        } else if (hours > 0) {
          DealTimer.innerHTML = `${hours}:${minutes}:${seconds}`;
        } else {
          DealTimer.innerHTML = `${minutes}:${seconds}`;
        }

        // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(x);
          if(_this2) _this2.setAttribute('hidden', '');
          let productDeal = _this2.querySelector('.Product__dealArea');
          if(productDeal) productDeal.style.display= "none";
        }
      }, 1000);
    }
  });
}

theme.InfluencerDeal = (function() {

  function InfluencerDeal(container) {
    var $container = (this.$container = container);
    var sectionId = $container.getAttribute('data-section-id');
    var DealTimer = $container.querySelector('#timer-' + sectionId);
    var endTime = $container.getAttribute("data-enddate");
    var endMessage = $container.getAttribute('data-end-message');
    
    // Set the date we're counting down to
    var countDownDate = new Date(endTime).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      // Display the result in the element
      if (days > 0) {
        DealTimer.innerHTML = `Nur noch ${days} Tage ${hours} Stunden, ${minutes} Minuten und ${seconds} Sekunden gültig.`;
      } else if (hours > 0) {
        DealTimer.innerHTML = `Nur noch ${hours} Stunden, ${minutes} Minuten und ${seconds} Sekunden gültig.`;
      } else {
        DealTimer.innerHTML = `Nur noch ${minutes} Minuten und ${seconds} Sekunden gültig.`;
      }

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        DealTimer.innerHTML = endMessage;
        var DiscountCode_Area = $container.querySelector('.Discount_codeArea');
        DiscountCode_Area.style.display= "none";
      }
    }, 1000);

  }

  return InfluencerDeal;
})();

theme.MultiColumn = (function() {

  function MultiColumn(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = '#MultiColumn-' + sectionId;

    var config = {
      watchCSS: true,
      wrapAround: true,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true
    }

    this.slideshow = new Flickity(slideshow, config);
    
    // add this code
    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };
  }
  
  MultiColumn.prototype = Object.assign({}, MultiColumn.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(evt) {
      var slide = document.querySelector(
        '.multicolumn-slide--' + evt.detail.blockId
      );
      var slideIndex = Number(slide.getAttribute('data-slide-index'));
      
      this.slideshow.select(slideIndex);
    },

    onBlockDeselect: function(evt) {
      // Resume Slideshow events
    }

  });

  return MultiColumn;
})();


theme.FeaturedArticles = (function() {
  
  var selectors = {
    prevButton: '[data-previous-button]',
    nextButton: '[data-next-button]'
  }

  function FeaturedArticles(container) {
    var _this1 = this;
    this.container = container;
    var sectionId = container.dataset.sectionId;
    var slideshow = '#ArticleList--' + sectionId;
    
    var config = {
      watchCSS: true,
      wrapAround: true,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true
    }

    var slideshow = (this.slideshow = new Flickity(slideshow, config));
    
    // Custom UI navigation
    // previous
    var previousButton = document.querySelector(selectors.prevButton);
    previousButton.addEventListener( 'click', function() {
      slideshow.previous();
    });
    // next
    var nextButton = document.querySelector(selectors.nextButton);
    nextButton.addEventListener( 'click', function() {
      slideshow.next();
    });
    
    this._attachListeners();
  }
  
  FeaturedArticles.prototype = Object.assign({}, FeaturedArticles.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    },

    _attachListeners: function(evt) {
      var _this2 = this;
      window.addEventListener('resize', function(){
        _this2.slideshow.resize();
      });
    }

  });

  return FeaturedArticles;
})();

theme.CartDrawer = (function() {
  var selectors = {
    drawer: '#CartDrawer',
    form: '#CartDrawerForm'
  };

  function CartDrawer() {
    this.form = document.querySelector(selectors.form);
    this.drawer = new theme.Drawers('CartDrawer', 'cart');

    this.init();
  }

  CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
    init: function() {

      document.addEventListener('product:added', function(evt) {
       this.open();
      }.bind(this));

      // Dev-friendly way to open cart
     document.addEventListener('cart:open', this.open.bind(this));
     document.addEventListener('cart:close', this.close.bind(this));
    },

    open: function() {
      this.drawer.open();
    },

    close: function() {
      this.drawer.close();
    }
  });

  return CartDrawer;
})();

theme.CartDrawerAjax = /*#__PURE__*/(function () {
  function CartDrawerAjax(container) {

    this.element = container;
    this.delegateElement = new Delegate(this.element);
    this.documentDelegate = new Delegate(document.documentElement);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.itemCount = this.options['itemCount'];

    if (this.options['drawer']) {
      if (!document.body.classList.contains('template-cart')) {
       this.sidebarDrawer = new theme.CartDrawer();
      }
    }

    this._attachListeners();
  }

  CartDrawerAjax.prototype = Object.assign({}, CartDrawerAjax.prototype, {  

    onUnload: function onUnload() {
      this.delegateElement.off();
      document.removeEventListener('product:added', this._onProductAddedListener);
    },

    _attachListeners: function _attachListeners() {
      this._onProductAddedListener = this._onProductAdded.bind(this);

      if (this.options['type'] !== 'page') {
        this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
        this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._updateItemQuantity.bind(this));
      } else {
        this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._reloadPageWithQuantity.bind(this));
      } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page


      document.addEventListener('product:added', this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart

      this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
    },

    _updateItemQuantity: function _updateItemQuantity(event, target) {
      var _this2 = this;

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      var quantity = null,
          elementToAnimate = null;

      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        quantity = parseInt(target.getAttribute('data-quantity'));
      } // If the quantity is 0, then we will animate the product with a removal effect


      if (quantity === 0) {
        elementToAnimate = target.closest('.CartItemWrapper');
      }

      fetch("".concat(window.routes.cart_change_url, ".js"), {
        body: JSON.stringify({
          line: target.getAttribute('data-line'),
          quantity: quantity
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      }).then(function (cart) {
        cart.json().then(function (content) {
          _this2.itemCount = content['item_count'];

          _this2._rerenderCart(elementToAnimate);

          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
      event.preventDefault();
    },

    _reloadPageWithQuantity: function _reloadPageWithQuantity(event, target) {
      window.location.href = "".concat(window.routes.cart_change_url, "?quantity=").concat(parseInt(target.value), "&line=").concat(target.getAttribute('data-line'));
    },

    _onProductAdded: function _onProductAdded(event) {
      var _this3 = this;

      this.itemCount += event.detail.quantity;

      this._rerenderCart().then(function () {
        _this3.sidebarDrawer.open();
      });
      document.dispatchEvent(new CustomEvent('cart:drawer:updated'));
    },

    /**
       * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
       * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
       * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
       * all the time and hence having easier logic.
       */

    _rerenderCart: function _rerenderCart(elementToAnimate) {
      var _this4 = this;

      // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
      return fetch("".concat(window.routes.cartUrl, "?section_id=").concat(this.options['drawer'] && window.theme.pageType !== 'cart' ? 'cart-drawer' : 'main-cart'), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        content.text().then(function (html) {
          _this4._replaceContent(html);
        });
      });
    },

    _replaceContent: function _replaceContent(html) {
      var _this5 = this;

      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      var cartNodeParent = this.element.querySelector('.Cart').parentNode;

      if (this.options['drawer'] && window.theme.pageType !== 'cart') {
        var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
        cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
        this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
      }
      
      // We can also update the dot and the quantity
      var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart-drawer"]').getAttribute('data-section-settings'));
      var cartDot = theme.Dom.nodeListToArray(document.querySelectorAll('.Header__CartDot'));
      var EmptyCart = theme.Dom.nodeListToArray(document.querySelectorAll('.empty-cart'));
      var NonEmptyCart = theme.Dom.nodeListToArray(document.querySelectorAll('.nonempty-cart'));
      
      this.itemCount = cartResult['itemCount'];
      cartDot.forEach(function (item) {
        if (_this5.itemCount === 0) {
          item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.add('is-visible');
        }
      });
      EmptyCart.forEach(function (item) {
        if (_this5.itemCount === 0) {
          item.classList.remove('hidden'); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.add('hidden');
        }
      });
      NonEmptyCart.forEach(function (item) {
        if (_this5.itemCount === 0) {
          item.classList.add('hidden'); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.remove('hidden');
        }
      });
      cartDot.forEach(function (item) {
        item.textContent = _this5.itemCount;
      });
    }

  });

  return CartDrawerAjax;
})();

theme.Instagram = (function() {

  function Instagram(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = '#instagram-' + sectionId;

    var config = {
      watchCSS: true,
      wrapAround: true,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true
    }

    this.slideshow = new Flickity(slideshow, config);
    
    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };
  }
  
  Instagram.prototype = Object.assign({}, Instagram.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(evt) {
      var slide = document.querySelector(
        '.Instagram-slide--' + evt.detail.blockId
      );
      var slideIndex = Number(slide.getAttribute('data-slide-index'));
      
      this.slideshow.select(slideIndex);
    },

    onBlockDeselect: function(evt) {
      // Resume Slideshow events
    }

  });

  return Instagram;
})();

theme.FeaturedCollection = (function() {

  function FeaturedCollection(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var mobileSlider = container.dataset.mobileSlider;
    var slideshow = '#featured-collection-' + sectionId;

    if (mobileSlider === 'false') return; 

    var config = {
      watchCSS: true,
      wrapAround: false,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true
    }

    this.slideshow = new Flickity(slideshow, config);
    
    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };
  }
  
  FeaturedCollection.prototype = Object.assign({}, FeaturedCollection.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    }
  });

  return FeaturedCollection;
})();

class SplitTimer extends HTMLElement {
  constructor() {
    super();
    var _this1 = this;
    
    this.onTimerIntialize();
  }

  onTimerIntialize(container) {
    let _this2 = this;
    var $container = (this.$container = this);
    var $parent = $container.querySelector('.announcement__top-countdown');
    var blockId = $parent.getAttribute('data-block-id');
    var DealTimer = this.$container.querySelector('#timer-' + blockId);
    var endTime = $parent.getAttribute("data-enddate");
    
    // Set the date we're counting down to
    var countDownDate = new Date(endTime).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      // Add Zero if value is below 10
      if (days < 10) days = "0" + days;
      if (hours < 10) hours = "0" + hours;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;
      
      // Display the result in the element
      if (days > 0) {
        DealTimer.innerHTML = `${days} Tage, ${hours} Stunden, ${minutes} Minuten, ${seconds} Sekunden`;
      } else if (hours > 0) {
        DealTimer.innerHTML = `${hours} Stunden, ${minutes} Minuten, ${seconds} Sekunden`;
      } else {
        DealTimer.innerHTML = `${minutes} Minuten, ${seconds} Sekunden`;
      }
      
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        
        if(_this2) _this2.classList.add('hidden');
        let DealWrapper = _this2.closest('.Split-Timer__bar');
        if(DealWrapper) DealWrapper.clssList.add("hidden");
      }
    }, 1000);
  }
  
}

customElements.define('split-timer', SplitTimer);

if (!customElements.get('video-object')) {
  class VideoObject extends HTMLElement {
    constructor() {
      super();

      this.mediaId = this.dataset.mediaId;
      if (!this.mediaId) return;

      this.mediaType = this.dataset.mediaType;
      this.loaded = JSON.parse(this.dataset.loaded);

      this.bindEvents();
    }

    bindEvents() {
      this.coverButton = this.querySelector('.video__cover-button');

      this.coverButton.addEventListener('click', (event) => {
        this.pauseAllMedia();
        if (!this.loaded) {
          const content = document.createElement('div');
          content.appendChild(
            this.querySelector('template').content.firstElementChild.cloneNode(
              true
            )
          );

          this.loaded = true;
          this.dataset.loaded = true;
          this.appendChild(
            content.querySelector('video, model-viewer, iframe')
          ).focus();

          this.video = this.querySelector('video, model-viewer, iframe');
        }

        if (this.mediaType === 'youtube') this.loadYouTubeAPI();

        // isOutOfView(this, (target) => {
        //   this.pauseMedia();
        // });

        event.preventDefault();
      });
    }
 
    loadYouTubeAPI() {
      if (window.YT !== undefined) {
        theme.youTubeApiStatus = 'ready';
      }
      if (
        theme.youTubeApiStatus !== 'loaded' ||
        theme.youTubeApiStatus !== 'ready'
      ) {
        const script = document.createElement('script');
        script.id = `youtube-iframe-api`;
        script.src = `https://www.youtube.com/iframe_api`;
        script.async = true;
        script.onload = () => {
          theme.youTubeApiStatus = 'loaded';
        };
        document.body.append(script);
      }
      if (theme.youTubeApiStatus === 'ready') {
        this.player = new YT.Player(this.video.id, {
          events: {
            onReady: () => this.onPlayerReady(),
          },
        });
      } else {
        window.onYouTubeIframeAPIReady = () => {
          this.player = new YT.Player(this.video.id, {
            events: {
              onReady: () => {
                this.onPlayerReady();
                theme.youTubeApiStatus = 'ready';
              },
            },
          });
        };
      }
    }

    onPlayerReady(player) {
      this.player.playVideo();
      // isOutOfView(this, (target) => {
      //   this.player.pauseVideo();
      // });
    }

    pauseMedia() {
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
          '*'
        );
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
      this.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

    pauseAllMedia() {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
          '*'
        );
      });
      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

  }
  customElements.define('video-object', VideoObject);
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (window.theme.cartType === 'drawer') {
            var quantityElement = this.form.querySelector('[name="quantity"]');
            // We simply trigger an event so the mini-cart can re-render
            this.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                quantity: quantityElement ? parseInt(quantityElement.value) : 1
              }
            }));
          }
        
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class DiscountBar extends HTMLElement {
  constructor() {
    super();

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.copyCoupon.bind(this))
    );
  }

  async copyCoupon() {
    const couponValue = this.getCouponValue();
    await this.copyTextToClipboard(couponValue);
    this.showTooltip('coupon-tooltip');
    this.showTooltip('coupon-tooltip-desktop');
  }

  getCouponValue() {
    return this.querySelector('#coupon').value;
  }

  async copyTextToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  showTooltip(tooltipId) {
    const tooltipElement = this.querySelector(`#${tooltipId}`);
    if (tooltipElement) {
      tooltipElement.style.display = 'block';
      tooltipElement.style.opacity = 1;
      tooltipElement.style.visibility = 'visible';
      setTimeout(() => this.hideTooltip(tooltipElement), 1000);
    }
  }

  hideTooltip(tooltipElement) {
    tooltipElement.style.display = 'none';
    tooltipElement.style.opacity = 0;
    tooltipElement.style.visibility = 'hidden';
  }
}

customElements.define('discount-bar', DiscountBar);


// AOS Fix for Section Events
document.addEventListener('shopify:section:load', function(){
  AOS.init();
});

document.addEventListener('shopify:block:select', function(){
  AOS.init();
});

// ReFresh AOS on Window Load
window.addEventListener('load', AOS.refresh);

// Intialize all function on DOMLoaded
document.addEventListener('DOMContentLoaded', function () {
  var sections = new theme.Sections();

  theme.Collapsibles();
  new theme.CollapsibleManager();

  sections.register('header', theme.HeaderSection);
  sections.register('cart-drawer', theme.CartDrawerAjax);
  sections.register('recommendation-products', theme.RecommendationSlider);
  sections.register('main-influencer', theme.InfluencerDeal);
  sections.register('multi-column', theme.MultiColumn);
  sections.register('featured-articles', theme.FeaturedArticles);
  sections.register('instagram', theme.Instagram);
  sections.register('featured-collection', theme.FeaturedCollection);
  // sections.register('product', theme.ProductSection);
  AOS.init();
  
  /**
     * ----------------------------------------------------------------------------
     * FLICKITY
     *
     * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
     * event.preventDefault to be called on dynamically added listeners, which is
     * what Flickity is using.
     *
     * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
     * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
     * and that we are using here as a temporary workaround, that should be removed
     * once the bug is fixed on iOS
     * ----------------------------------------------------------------------------
     */

  Flickity.defaults.dragThreshold = 7;

  (function () {
    var touchingCarousel = false,
        touchStartCoords;
    document.body.addEventListener('touchstart', function (e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      };
    });
    document.body.addEventListener('touchmove', function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };
      if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault();
    }, {
      passive: false
    });
  })();
  /**
     * ----------------------------------------------------------------------------
     * FLICKITY 2
     *
     * Starting from iOS 15, Safari on iOS automatically starts to expand/collapse
     * the bottom bar as soon as you do even a minor diagonal movement. This is causing
     * a performance issue on iOS15 as it does a lot of reflow. We therefore have to
     * patch Flickity to make sure they re-size the carousel only when the width is
     * changed, by ignoring the height
     * ----------------------------------------------------------------------------
     */


  (function () {
    if (window.Flickity) {
      var originalResizeMethod = window.Flickity.prototype.resize,
          lastWidth = window.innerWidth;

      window.Flickity.prototype.resize = function () {
        if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
          return;
        }

        lastWidth = window.innerWidth;
        originalResizeMethod.apply(this, arguments); // Call original method
      };
    }
  })();
  
  // Page Loaded Event
  document.dispatchEvent(new CustomEvent('page:loaded'));
  
});

(function () {
/**
    * ----------------------------------------------------------------------------
    * Size Chart
    * ----------------------------------------------------------------------------
    */
 (function () {
   	const modalTriggers = document.querySelectorAll('.popup-trigger');
    const modalCloseTrigger = document.querySelector('.popup-modal__close');
    const bodyBlackout = document.querySelector('.SizeChart__Overlay');

    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const { popupTrigger } = trigger.dataset;
        const popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`);

        popupModal.classList.add('is--visible');
        bodyBlackout.classList.add('is-visible');

        popupModal.querySelector('.popup-modal__close').addEventListener('click', () => {
           popupModal.classList.remove('is--visible');
           bodyBlackout.classList.remove('is-visible');
        });

        bodyBlackout.addEventListener('click', () => {
          popupModal.classList.remove('is--visible');
          bodyBlackout.classList.remove('is-visible');
        });

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode == 27) {
            popupModal.classList.remove('is--visible');
            bodyBlackout.classList.remove('is-visible');
          }
        };

      });
    });
 })();

})();


(function () {
/**
    * ----------------------------------------------------------------------------
    * RTE
    * ----------------------------------------------------------------------------
    */
 (function () {
   // We wrap each RTE table by a specific class to allow wrapping
   var Dom = document.body;
   Dom.querySelectorAll('.Rte table').forEach(function (table) {
     table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
   });
   Dom.querySelectorAll('.Rte iframe').forEach(function (iframe) {
     // We scope the wrapping only for YouTube and Vimeo
     if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
       iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
       // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

       iframe.src = iframe.src;
     }
   });
 })();

})();

(function () {
/**
    * ----------------------------------------------------------------------------
    * Product Grid Video
    * ----------------------------------------------------------------------------
    */
  // (function () {

  //   function isElementInViewport(el) {
  //       const rect = el.getBoundingClientRect();
  //       return (
  //           rect.top >= 0 &&
  //           rect.left >= 0 &&
  //           rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
  //           rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  //       );
  //   }
    
  //   function handleVisibilityonScroll() {
  //       const videos = document.querySelectorAll('product-card video');
        
  //       videos.forEach(video => {
  //           if (isElementInViewport(video.parentNode.parentNode.parentNode)) {
  //             if(video) video.play();
  //           } else {
  //             if(video) video.pause();
  //           }
  //       });
  //   }
    
  //   // Initial check
  //   //handleVisibilityonScroll();
    
  //   // Attach the event listener to check for visibility on scroll
  //   window.addEventListener('scroll', handleVisibilityonScroll);
    
  //   // Function to handle visibility changes for videos
  //   function handleVisibility(entries, observer) {
  //     entries.forEach(entry => {
  //         const video = entry.target.querySelector('video');
    
  //         if (entry.isIntersecting) {
  //           if(video) video.play();
  //         } else {
  //           if(video) video.pause();
  //         }
  //     });
  //   }
    
  //   // Create an Intersection Observer instance
  //   const cardObserver = new IntersectionObserver(handleVisibility, {
  //     root: 0 || null, // Use the viewport as the root
  //     rootMargin: '0px', // No margin around the viewport
  //     threshold: 0.5 // Trigger when 50% of the product card is visible
  //   });
    
  //   // Target all product card elements
  //   const productCards = document.querySelectorAll('product-card');
    
  //   productCards.forEach(card => {
  //     // Observe each product card element
  //     cardObserver.observe(card);
  //   });
    
  //   // Attach the event listener to disconnect the observer on scroll
  //   window.addEventListener('scroll', () => {
  //     // Trigger the Intersection Observer to update visibility status
  //     cardObserver.takeRecords();
  //     cardObserver.observe(productCards); // Reobserve product cards to update visibility
  //   });
    
  //   // Initial check
  //   cardObserver.observe(productCards); // Observe product cards for the initial check

  //  })();

  (function () {

    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    
    function handleVisibilityonScroll() {
        const videos = document.querySelectorAll('product-card video');
        
        videos.forEach(video => {
            if (isElementInViewport(video.parentNode.parentNode.parentNode)) {
              if(video) video.play();
            } else {
              if(video) video.pause();
            }
        });
    }
    
    // Attach the event listener to check for visibility on scroll
    window.addEventListener('scroll', handleVisibilityonScroll);
    
    // Function to handle visibility changes for videos
    function handleVisibility(entries, observer) {
      entries.forEach(entry => {
          const video = entry.target.querySelector('video');
    
          if (entry.isIntersecting) {
            if(video) video.play();
          } else {
            if(video) video.pause();
          }
      });
    }
    
    // Create an Intersection Observer instance
    const cardObserver = new IntersectionObserver(handleVisibility, {
      root: null, // Use the viewport as the root
      rootMargin: '0px', // No margin around the viewport
      threshold: 0.5 // Trigger when 50% of the product card is visible
    });
    
    // Target all product card elements
    const productCards = document.querySelectorAll('product-card');
    
    productCards.forEach(card => {
      // Observe each product card element
      cardObserver.observe(card);
    });
    
    // Initial check
    handleVisibilityonScroll(); // Call this to check visibility on load

})();

})();

// Patch to remove _agentClientInfo from order added by third-party app.
(function () {
  function clearAgentAttr(proceed) {
    fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { _agentClientInfo: "" } }),
    }).then(proceed);
  }

  // 1. Catch all checkout button clicks (capture phase)
  document.addEventListener(
    "click",
    function (e) {
      const el = e.target.closest(
        '[href="/checkout"], [name="checkout"], [href*="/checkout"]'
      );
      if (el) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearAgentAttr(() => {
          window.location.href = (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"checkout";
        });
      }
    },
    true
  );

  // 2. Catch form submissions pointing to /checkout
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (form.action && form.action.includes("/checkout")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearAgentAttr(() => form.submit());
      }
    },
    true
  );

  // 3. Poll & clear every 3s as a safety net
  setInterval(() => {
    fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart.js")
      .then((r) => r.json())
      .then((cart) => {
        if (cart.attributes && cart.attributes._agentClientInfo) {
          fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { _agentClientInfo: "" } }),
          });
        }
      });
  }, 3000);
})();